import React, {useState,useEffect, Fragment} from "react";
import { Link, useNavigate } from "react-router-dom";
import { RichTextEditor } from '@mantine/rte';
import { api, rules,sportlist } from "../../apis/urls";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { DatePicker } from "antd";

const AddRules =()=> {

    useEffect( ()=>{
        cricketListing();
    },[])

	let navigate = useNavigate();
	const RoutToList = () =>{
        navigate("/rules")
    }

    const initialValue ='<p></p>';


    const [result,setResult] = useState([]);
    
    const [name,setName] = useState('');
    const [sports,setSports] = useState('');
    //const [amount,setAmount] = useState('');
    const [instructions,setInstructions] = useState(initialValue);
    const [marks,setMarks] = useState('');
    const [status,setStatus] = useState('');
    const [test_lastDate,setTest_lastDate] = useState('');

    const [imgLoad, setImgLoad] = useState(false)

    const [nameerror,setNameerror] = useState(false);
    const [sportserror,setSportserror] = useState(false);
    //const [amounterror,setAmounterror] = useState(false);
    const [minmarkerror,setMinmarkerror] = useState(false);
    const [statuserror,setStatuserror] = useState(false);
    const [dateerror,setDateerror] = useState(false);
    const [percentageless,setPercentageless] = useState(false);
    const [percentagemore,setPercentagemore] = useState(false);
    const instructionset = (text) =>{
        //console.log(text)
 
        
        setInstructions(text)
    }

    const cricketListing = ()=>{

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: sportlist+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data.items);
            
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });


    }

    const OnFormClick = () => {
        let error = 0;

        if(name === '')
        {
            setNameerror(true)
            error =1;
        }else{
            setNameerror(false)
            error =0;
        }


        if(sports === '')
        {
            setSportserror(true)
            error = 1;
            
        }else{
            setSportserror(false)
            error = 0;
        }

        // if(amount === '')
        // {
        //     setAmounterror(true)
        //     error = 1;
            
        // }else{
        //     setAmounterror(false)
        //     error = 0;
        // }
        if(marks === '')
        {
            setMinmarkerror(true)
            setPercentageless(false)
            setPercentagemore(false)
            error = 1;
            
        }else if(marks<1)
        {
            setMinmarkerror(false)
            setPercentageless(true)
            setPercentagemore(false)
            error = 1;

        }else if(marks>100)
        {       
            setMinmarkerror(false)
            setPercentagemore(true)
            setPercentageless(false)
            error = 1;

        }else{
            setMinmarkerror(false)
            setPercentageless(false)
            setPercentagemore(false)
            error=0;
        }
        // if(status === '')
        // {
        //     setStatuserror(true)
        //     error = 1;
            
        // }else{
        //     setStatuserror(false)
        //     error = 0;
        // }
        if(test_lastDate === '')
        {
            setDateerror(true)
            error = 1;
            
        }else{
            setDateerror(false)
            error = 0;
        }
       
        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)
        const data = {
            name :name,
            sport_id :sports,
            //amount:amount,
            instructions:instructions,
            min_mark:marks,
            status :'ACTIVE',
            test_lastDate:test_lastDate,
            image:fileUp
        }
        //console.log('all datas',data)
        const instance = axios.create({

            baseURL: rules,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.post('',data).then((response) =>{

            console.log(response.data)
            
            let path = 'newPath'; 
            navigate("/rules")
           
          }).catch((error) =>{
            
            //console.log('error',error.message)

            //setNameerror('Enter the Name')
            

          });
    }



    const [fileUp, setFileUp] = useState('');
    const [fileSelect, setFileSelect] = useState('');


    const  changeHandler=(event)=>{

        setImgLoad(true)

        setFileSelect(event.name)

        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{

            console.log("respooonse", response.data)
            setFileUp(response.data.Location)

            setImgLoad(false)

        }).catch((error) =>{  
            setImgLoad(false)   
            console.log('error',error.message)  
        });

    }


 
    return(<>

        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    

                <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">Add Test</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        
                        
                    </div>
                
                
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/rules">Rules Tests</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Add Test</li>
                    </ol>
                </nav>

                <div className="form-wrpr">
                    <div className="card formcard small">
                        <div className="card-body">
                            <div className="form-group">
                                <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                <input type="text" value={name} onChange={e => {setName(e.target.value)}} className="form-control bg-dark dark-theme showtext"
                                placeholder="Enter Name" id="name"></input>
                                {
                                nameerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter Name</div>
                                :null
                                }
                            </div>
                            <div className="form-group">
                                <label className="degreehead">Sports <span style={{color: "red"}}>*</span></label>
                                <select onChange={e => {setSports(e.target.value)}} className="form-control bg-dark dark-theme showtext" id="status-selector">
                                    <option value="0">Select Sports</option>
                                    {result?.map((item,index)=> (
                                        <Fragment>
                                        {item.status === "ACTIVE"?
                                        <option value={item.id} key={index}>{item.name}</option>:null
                                        }
                                        </Fragment>
                                    ))}
                                    
                                    
                                </select>
                                {
                                sportserror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select sports</div>
                                :null
                            }
                            </div>

                            { /*<div className="form-group">
                                <label className="degreehead">Charge <span style={{color: "red"}}>*</span></label>
                                <input type="number" value={amount} onChange={e => {setAmount(e.target.value)}} className="form-control bg-dark dark-theme showtext" defaultValue="$" placeholder="Enter Charge" id="name"></input>
                                {
                                amounterror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter Amount</div>
                                :null
                            }
                        </div> */ }

                            <div className="form-group">
                                <label className="degreehead">Instructions</label>
                                <RichTextEditor className="Desc-RTE" value={instructions} onChange={instructionset}/>
                            </div>
                   
                            <div className="form-group">
                                <label className="degreehead">Pass % <span style={{color: "red"}}>*</span></label>
                                <input type="number" value={marks} onChange={e => {setMarks(e.target.value)}} className="form-control bg-dark dark-theme showtext" placeholder="Enter percentage" id="name"></input>
                                {
                                minmarkerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter percentage</div>
                                :null
                                }

                                {                   
                                    percentageless
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter valid percentage</div>
                                    :null
                                }

                                {                   
                                    percentagemore
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter valid percentage</div>
                                    :null
                                }



                            </div>

                            <div className="form-group">
                                <label className="degreehead">Last date for test<span style={{color: "red"}}>*</span></label>
                                <div className="row">
                                <div className="col-md-12">
                                    <DatePicker 
                                        oneTap={true}
                                        style={{width:'100%', background:'#e6e8eaab', height:"45px"}} 
                                        onChange={(date)=>{
                                            const d = new Date(date).toLocaleDateString('fr-FR');
                                            setTest_lastDate(date)
                                        }} 
                                        format={'MM-DD-YYYY'}
                                        placeholder={"Last Date (MM-DD-YYYY)"}
                                    />

                                </div>
                                </div>

                                        {                   
                                            dateerror
                                            ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter date</div>
                                            :null
                                        }
                                        
                            </div>

                            <div className="form-group">
                                <label className="degreehead">Upload image</label>
                                <div>
                                    <div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
                                    <input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}}  />	
                                    {!fileUp?
                                        <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>:
                                        <img src={fileUp} width="5%" />
                                    }
                                    <span class='labels' style={{color:fileUp?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:fileUp?'10px':null }} data-js-label>{!fileSelect?"No file selected":fileSelect}</span>
                                    </div>
                                </div>
							</div>

                            <div className="form-group text-right">
                                <button onClick={RoutToList} className="btn btn-danger btn-gisa" type="submit">Cancel</button>
                                <button disabled={imgLoad?true:false} onClick={OnFormClick} className="btn btn-primary btn-gisa" type="button">Create</button>
                            </div>


                        </div>
                    </div>
                </div>


                </div>
            </aside>
        </div>

    </>)
}

export default AddRules